const landing_page = {
  aboutUs: "עלינו", // translated
  topPackages: "חבילות מובילות", // translated
  featuredHotels: "מלונות מומלצים", // translated
  topTours: "סיורים מובילים", // translated
  whatOurMembersSay: "מה החברים שלנו אומרים...", // translated
  followUsOnInstagram: "עקבו אחרינו באינסטגרם", // translated
  pleaseWait: "המתן בבקשה...", // translated
  packages: "חבילות", // translated
  ourPartners: "השותפים שלנו", // translated
  trustedCarHirePartners: "שותפים מהימנים להשכרת רכב", // translated
  learnMore: "למד עוד", // translated
};


export default landing_page;
